import $ from 'jquery';
// Ensure tosrus has been loaded (it's a jquery plugin)
import 'tosrus';

const PLUGIN = 'tosrus';

export let tosrus = $[PLUGIN];

export class BaseTosRUsMediaPlugin {
    constructor() {

        this.initialised = false;

        // Wrap the tosrus API methods to support its unusual calling contention
        for(let op of ['filter', 'init']) {
            for(let type of ['Anchors', 'Slides']) {
                let name = op + type;
                this[name] = this.createTosApiMethod(this[name]);
            }
        }
    }

    get tos() {
        if(this._tos === undefined) {
            throw new Error('this.tos referenced while uninitialised');
        }
        return this._tos;
    }

    /**
     * TosRUs defers the initialisation of its globals until the first time
     *  it's called, so we can't initialise them on startup.
     */
    _doDeferredInit() {
        if(this.initialised === true)
            return;
        this.init();
        this.initialised = true;
    }

    init() {
        this._tos = {
            classes: tosrus._c,
            data: tosrus._d,
            events: tosrus._e,
            funcs: tosrus._f,
            globals: tosrus._g
        };
    }

    /**
     * Create a method which handles the this parameter passed by tos while
     * maintaining our actual plugin instance.
     */
    createTosApiMethod(targetMethod) {
        let self = this;
        return function() {
            // tosrus calls plugin methods with this set to its own context info
            let tosContext = this;

            // At the point that an api method is called, it's safe to
            // initialise.
            self._doDeferredInit();

            // Invoke the actual api method implementation with the context
            // as the first argument (instead of as this).
            return targetMethod.apply(self, [tosContext].concat([].slice.apply(arguments)));
        }
    }
}



/** WEBPACK FOOTER **
 ** ./js/view/components/lightbox/tosrus.js
 **/